<template>
  <v-layout justify-center>
    <v-dialog width="1200px" v-model="show_error_dialog" persistent max-width="800">
      <error-message :error_message="error_message" @closeDialog="closeDialog" />
    </v-dialog>
  </v-layout>
</template>

<script>
import AdminPartnerConfigMessage from "./AdminPartnerConfigMessage"

export default {
  name: 'AdminPartnerConfigDialogMessage',
  components: { 
    'error-message': AdminPartnerConfigMessage
  },
  props: {
    show_error_dialog: {
      type: Boolean
    },
    error_message: {
      type: String
    }
  },
  data(vm) {
    return {}
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    }
  },
  computed: {
  },
  metaInfo: {
    title: "Facilita Pay - Admin Partner Config Dialog Message"
  }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/AdminPartnerConfigDialogMessage.vue